import { render } from "./costCenters.vue?vue&type=template&id=2857963c&scoped=true"
import script from "./costCenters.vue?vue&type=script&lang=js"
export * from "./costCenters.vue?vue&type=script&lang=js"

import "./costCenters.vue?vue&type=style&index=0&id=2857963c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2857963c"]])

export default __exports__